module.exports = __webpack_public_path__ + "static/media/icon_count.bc38d84c.svg";